import { Helper } from '../Helper';
export class GetCommonStorageHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            return;
        }
        sb.emitHelper(node, options, sb.helpers.commonStorage);
        sb.emitOp(node, 'TUCK');
        sb.emitOp(node, 'OVER');
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'HASKEY');
            },
            whenTrue: () => {
                sb.emitOp(node, 'PICKITEM');
            },
            whenFalse: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                sb.emitPushBuffer(node, Buffer.alloc(0, 0));
            },
        }));
    }
}

//# sourceMappingURL=GetCommonStorageHelper.js.map
